import React, {FormEvent, FormHTMLAttributes, useRef} from "react";
import {PropsWithOverwrite} from "../../../utils/input";

export enum FormValidationType {
    NATIVE,
    CUSTOM,
    NONE
}

type FormProps = Omit<PropsWithOverwrite<FormHTMLAttributes<HTMLFormElement>, {
    validationType?: FormValidationType;
    autoComplete?: boolean;
    cssClass?: string;
}>, "noValidate">;

const Form: React.FunctionComponent<FormProps> = ({children, validationType = FormValidationType.NATIVE, autoComplete, cssClass, onSubmit, ...formAttr}) => {
    const formRef = useRef<HTMLFormElement | null>(null);

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        if (validationType === FormValidationType.NONE || !formRef.current || formRef.current.checkValidity()) {
            onSubmit && onSubmit(e);
        } else {
            e.preventDefault();
        }
    };

    return (
        <form
            ref={formRef}
            autoComplete={autoComplete ? "on" : "off"}
            noValidate={[FormValidationType.CUSTOM, FormValidationType.NONE].includes(validationType)}
            className={cssClass}
            onSubmit={handleSubmit}
            {...formAttr}
        >
            {children}
        </form>
    );
};

export default Form;
